<template>
    <v-list dense class="pa-0">
        <v-list-item-group v-model="selectItems" :rules="[isRequired ? rules.required : rules.alwaysValid]" multiple>
            <template v-for="(item, fieldIndex) in getSelectItemsArray(field.select_items)">
                <v-list-item :key="fieldIndex" class="pa-0" :value="item" :disabled="isDisabled">
                    <template v-slot:default="{ active }">
                        <v-list-item-action>
                            <v-checkbox
                                :input-value="active"
                                :disabled="isDisabled"
                                :rules="[isRequired ? rules.isCheckValid(selectItems) : rules.alwaysValid]"
                                color="accent"
                                class="mt-0 mb-4"
                            />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title
                                :class="`${$options.name}__ListBodyText`"
                                style="white-space: pre-wrap"
                                v-text="item"
                            />
                        </v-list-item-content>
                    </template>
                </v-list-item>
            </template>
        </v-list-item-group>
        <v-layout v-if="isRequired && !rules.isCheckValid(selectItems)">
            <v-flex class="pl-0 shape cutie red--text" style="font-size: 12px">
                {{ $t('validate_message.Required_field') }}
            </v-flex>
        </v-layout>
    </v-list>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import type { TemplateCustomizeField } from '../../store/modules/application_form_template/types';
import InputValidation from '../../mixins/InputValidation';

@Component({
    name: 'CustomizedFieldCheckboxList',
})
export default class CustomizedFieldCheckboxList extends mixins(InputValidation) {
    @Prop({ default: undefined }) readonly field: TemplateCustomizeField;
    @Prop({ default: undefined }) readonly value: string | undefined;
    @Prop({ default: false }) readonly disabled: boolean;

    // v-modelにselectItemsを設定しているので、値に変更があった場合、親コンポーネントのchangeイベントで変更値を設定する(immediate: trueで変更なしでも一度実行される)
    @Watch('selectItems', { immediate: true })
    onSelectItemsChanged(val: Array<string>): void {
        this.$emit('change', this.id, val, this.field.select_items);
    }

    // 初期値の設定
    selectItems: Array<string> = this.getSelectItemsArray(this.initialValue);

    /**
     * getters
     */
    get isRequired(): boolean {
        return this.field.required;
    }

    get isDisabled(): boolean {
        return this.disabled;
    }

    get initialValue(): string {
        // 値が定義なしの場合、設定値として選択項目初期値を返す
        if (this.value === undefined) {
            return this.field.default_input;
        }

        return this.value;
    }

    get id(): number {
        return this.field.id;
    }

    /**
     * methods
     */
    getSelectItemsArray(val: string): Array<string> {
        if (!val) return [];
        return val.split(',');
    }
}
</script>
